import(/* webpackMode: "eager" */ "/codebuild/output/src4022599541/src/apps/jumplab/src/assets/images/icons/icon-home.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4022599541/src/apps/jumplab/src/components/icon/FaIcon/FaIcon.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4022599541/src/apps/jumplab/src/components/ui/BreadCrumb/BreadCrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4022599541/src/apps/jumplab/src/components/ui/LoadingLink/LoadingLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4022599541/src/apps/jumplab/src/features/gfProduct/components/ProductDetailContainerFromProductPage/ProductDetailContainerFromProductPage.tsx");
